import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios';
import store from '../store'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'mainContainer',
    component: () => import('../views/mainContainer.vue'),

  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home.vue'),

  },
  {
    path: '/errorPage',
    name: 'errorPage',
    component: () => import('../views/errorPage.vue'),
    protected: false


  },
  {
    path: '/map',
    name: 'map',
    component: () => import('../views/mapStories.vue'),
    protected: false
  },
  {
    path: '/createNewStory',
    name: 'createNewStory',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/createNewStory.vue'),
    children: [{
        path: 'createNewStoryContent',
        name: 'createNewStoryContent',
        component: () => import('../views/createNewStoryContent.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'createNewStoryPublish',
        name: 'createNewStoryPublish',
        component: () => import('../views/createNewStoryPublish.vue'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/splashScreen',
    name: 'splashScreen',
    component: () => import('../views/splashScreen.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/createNewJourneyContent',
    name: 'createNewJourneyContent',
    component: () => import('../views/createNewJourneyContent.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/singleStoryMapView',
    name: 'singleStoryMapView',
    component: () => import('../views/singleStoryMapView.vue'),
    meta: {
      requiresAuth: true
    }

  },
  {
    path: '/singleStoryKGView',
    name: 'singleStoryKGView',
    component: () => import('../views/singleStoryKGView.vue'),
    meta: {
      requiresAuth: true
    }

  },
  
  {
    path: '/addStoryInJourney',
    name: 'addStoryInJourney',
    component: () => import('../views/addStoryInJourney.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/carouselForSingleStoryView',
    name: 'carouselForSingleStoryView',
    component: () => import('../views/carouselForSingleStoryView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/termsAndConditions',
    name: 'termsAndConditions',
    component: () => import('../views/termsAndConditions.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/loginFirstTime',
    name: 'loginFirstTime',
    component: () => import('../views/loginFirstTime.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/singleJourneyView',
    name: 'singleJourneyView',
    component: () => import('../views/singleJourneyView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mapStoriesIframe',
    name: 'mapStoriesIframe',
    component: () => import('../mapStoriesIframe.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/404.vue'),
    meta: {
      requiresAuth: false
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//route guard
router.beforeEach((to, from, next) => {
  if(to.meta.requiresAuth&&localStorage.getItem('loadingTimeStampStart')!=null) {
    const status = localStorage.getItem('access_token')

    // se non ho l'access token ma sto aprendo carouselForSingleStoryView o singleJourneyView o sto aprendo pagina da ARpp: loggo l'utente come guest 
    if (status === null && ((to.name == 'carouselForSingleStoryView' || to.name == 'singleJourneyView' || to.name == 'mapStoriesIframe') || to.query.ARapp)) {
      console.log("if I don't have the access token but am opening carouselForSingleStoryView or singleJourneyView or opening page from ARpp: I log the user as guest")
      axios.post(
      "https://memex-staging.westus2.cloudapp.azure.com/v2/login", {
      user: 'Guest',
      password: 'GuestGuest'
      }).then(response => {
      //must wait to write user data in store.
      store.dispatch("setUserLoginData", response.data).then(()=>

      next()
      )
      }).catch(err => {
      console.log(err)})
    }
    else {
    //se non ho l'access token ma sono sulla pagina login / login first time
    if (status != null) {

      next()
    }
    else {

    next(router.go({
      name: 'loginFirstTime'
    }))
    }
  }
}
else next()
    })

export default router
